import memoize from "memoize-one";
import { IStore } from "reducers";
import { Kinds } from "constants/product-collection";
import { parseSchema, ISchemaKey } from "helpers/product-collection";
import { parseDoorCollection } from "helpers/door-collection";
import { AllocationDimensionIndex } from "helpers/allocation-dimension";
import {
    getAllocationDimensionValues,
    getAllocationDimensionAttributes,
    getRollupAllocationDimensionValues,
} from "./collection-allocation-dimension";
import { getCollectionItemDisplayProperty } from "./collection";

const defaultDoors = [];
export const getDoors = (state: IStore, collectionId: string, poi?: string) => {
    const doorsCollection =
        getAllocationDimensionValues(state, collectionId, AllocationDimensionIndex.Door, poi) || defaultDoors;
    const doorsDisplayProperties = getDoorClassificationSchema(state, collectionId, poi);
    const itemDisplayProperty = getCollectionItemDisplayProperty(state, collectionId);
    const { formulaFields } = parseSchema(itemDisplayProperty);

    return parseDoorCollection(doorsCollection, doorsDisplayProperties, formulaFields);
};

export const getRollupDoors = (state: IStore, collectionId: string, poi?: string) => {
    const doorsCollection =
        getRollupAllocationDimensionValues(state, collectionId, AllocationDimensionIndex.Door, poi) || defaultDoors;
    const doorsDisplayProperties = getDoorClassificationSchema(state, collectionId, poi);
    const itemDisplayProperty = getCollectionItemDisplayProperty(state, collectionId);
    const { formulaFields } = parseSchema(itemDisplayProperty);

    return parseDoorCollection(doorsCollection, doorsDisplayProperties, formulaFields);
};

const getClassificationDisplayProperties = memoize((displayProperties: ISchemaKey[]) => {
    return displayProperties.filter(
        (doorsDisplayProperty) => doorsDisplayProperty.kind === Kinds.ALLOCATION_DIMENSION_CLASSIFICATION
    );
});

const defaultDoorsAttributes = [];
export const getDoorClassificationSchema = (state: IStore, collectionId: string, poi?: string) => {
    const doorsDisplayProperties =
        getAllocationDimensionAttributes(state, collectionId, AllocationDimensionIndex.Door, poi) ||
        defaultDoorsAttributes;
    return getClassificationDisplayProperties(doorsDisplayProperties);
};
